/**
 * Function to hash a string using the Web Crypto API.
 * @param {string} message - The string to hash.
 * @param {string} [algorithm='SHA-256'] - The hashing algorithm to use (default is SHA-256).
 * @returns {Promise<string>} - A promise that resolves to the hexadecimal representation of the hash.
 * @throws {Error} - Throws an error if the Web Crypto API is not available or if hashing fails.
 */
async function hashString(message = '', algorithm = 'SHA-256') {
  if (!window?.crypto?.subtle) {
    throw new Error('Web Crypto API is not supported in this environment.');
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(message);

  try {
    const hashBuffer = await crypto.subtle.digest(algorithm, data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hexHash = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

    return hexHash;
  } catch (error) {
    throw new Error(`Hashing failed: ${error.message}`);
  }
}

export default hashString;
